import { Divider } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ProductMetadataV2Wrapper = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    alignItems: "start",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
}));

export const DividerStyled = styled(Divider)({
    alignSelf: "stretch",
    height: "auto",
});
